/* eslint-disable */
import React from "react";
import { Radios, Select, TextField } from "mui-rff";
import { Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { LoadingButton } from "@mui/lab";
import { TProductForm } from "@/features/products/create/types";
import { AutocompleteWrapper as Autocomplete } from "@/components/forms";
import { Grid, IconButton, InputAdornment, OutlinedInput, Stack, Switch, Tooltip, Typography } from "@mui/material";
import NumberFormatCustom from "@/components/forms/NumberFormat";
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import MenuItemModalForm from "@/components/modal/MenuItemModalForm";
import { getDecimals } from "@/helpers/local-storage";
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

/*const SelectFormAdapter = ({input, inputOnChange, ...other}: any) => {
    const inputProps = {
        ...input,
        onChange: (e: any) => {
            input.onChange(e);
            inputOnChange && inputOnChange(e);
        },
        ...other
    };

    return <TextField {...inputProps} />;
};*/

const ProductForm = (
    {
        onSubmit,
        initialValues,
        validateForm,
        required,
        submitting,
        selectDataProductType,
        selectDataUnit,
        selectDataTaxObject,
        selectDataPriceType,
        selectDataIVA,
        selectDataIVAWithHolding,
        isModal,
        icon,
        onChangeTaxObject,
        checkedTax,
        handleChangeTax,
        callback,
        setModalOpen,
        loading
    }: TProductForm): any => {

    const [t] = useTranslation();

    const decimalScale = getDecimals();

    // para revisiones de tamaños del modal
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const direction: string = (fullScreen) ? 'rows' : 'columns';

    const getFormFields = (values: any) => {
        return [
            {
                field:
                    <>

                        <FormControl>
                            <RadioGroup>
                                <Radios
                                    label="Tipo de concepto"
                                    name="productos_tipo"
                                    required={required.productos_tipo}
                                    data={selectDataProductType}
                                />
                            </RadioGroup>
                        </FormControl>




                        <Stack
                            direction={(fullScreen) ? 'column' : 'row'}
                            spacing={2}
                        >
                            <div style={{ width: (fullScreen) ? '100%' : '25%' }}>
                                <TextField

                                    InputLabelProps={{ shrink: true }}
                                    label={t("product.label_sat_key")}
                                    name="productos_claveprodserv"
                                    required={required.productos_claveprodserv}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Tooltip title={t('product.tooltip_sat_cat')}>
                                                    <IconButton aria-label="SAT" onClick={() => window.open(`${process.env.SAT_CAT_URL}`)} sx={{ color: 'primary.main' }}>
                                                        <Icon icon={searchFill} />
                                                    </IconButton>
                                                </Tooltip>
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                            </div>
                            <div style={{ width: (fullScreen) ? '100%' : '25%' }}>
                                <TextField

                                    InputLabelProps={{ shrink: true }}
                                    label={t("product.label_description")}
                                    name="productos_descripcion"
                                    required={required.productos_descripcion}
                                />
                            </div>
                            <div style={{ width: (fullScreen) ? '100%' : '25%' }}>
                                <TextField

                                    InputLabelProps={{ shrink: true }}
                                    label={t("product.label_id_number")}
                                    name="productos_numero_identificacion"
                                    required={required.productos_numero_identificacion}
                                />
                            </div>
                            <div style={{ width: (fullScreen) ? '100%' : '25%' }}>
                                <Autocomplete

                                    placeholder={t("product.placeholder_unit")}
                                    limitTags={1}
                                    label={t("product.label_unit")}
                                    name="productos_cat_units_id"
                                    multiple={false}
                                    required={required.productos_cat_units_id}
                                    options={selectDataUnit}
                                    selectOnFocus
                                    clearOnBlur
                                    handleHomeEndKeys
                                    disableClearable={true}
                                    disableCloseOnSelect={false}
                                    textFieldProps={{
                                        InputLabelProps: { shrink: true }
                                    }}
                                />
                            </div>
                        </Stack>

                        <Stack
                            direction={(fullScreen) ? 'column' : 'row'}
                            spacing={2}
                        >
                            <div style={{ width: (fullScreen) ? '100%' : '25%', marginTop: '10px' }}>
                                <Radios
                                    label=""
                                    name="productos_valor"
                                    required={required.productos_valor}
                                    data={selectDataPriceType}
                                />
                            </div>
                            <div style={{ width: (fullScreen) ? '100%' : '25%', marginTop: '20px' }}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    label={(values.productos_valor === '0') ? t("product.label_unit_price") : t("product.label_total_import")}
                                    name="productos_precio_unitario"
                                    required={required.productos_precio_unitario}
                                    InputProps={{
                                        inputComponent: NumberFormatCustom,
                                    }}
                                    inputProps={{
                                        decimalScale: decimalScale,
                                        prefix: '',
                                        fixedDecimalScale: true
                                    }}
                                />
                            </div>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Switch
                                    sx={{ ml: -1.4, mr: -1 }}
                                    checked={checkedTax}
                                    onChange={handleChangeTax}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                                <Typography
                                    variant={"body1"}
                                    gutterBottom
                                    sx={{ ml: 1, /*color: '#637381'*/ }}
                                >
                                    {(checkedTax) ? `Tiene impuestos` : `No tiene impuestos`}
                                </Typography>
                            </Stack>
                        </Stack>

                        <Stack direction="column" spacing={1} alignItems="flex-start" sx={{ ml: 0, mb: 2 }}  >

                        </Stack>
                        <Stack
                            direction={(fullScreen) ? 'column' : 'row'}
                            spacing={2}
                        >
                            {
                                (checkedTax) && (
                                    <>
                                        <div style={{ width: (fullScreen) ? '100%' : '25%', marginTop: '20px' }}>
                                            <Select
                                                label={t("product.label_iva")}
                                                name="productos_cat_vat_taxes_id"
                                                required={required.productos_cat_vat_taxes_id}
                                                data={selectDataIVA}
                                                multiple={false}
                                                inputLabelProps={{ shrink: true }}
                                                displayEmpty
                                                input={
                                                    <OutlinedInput notched={true} label={t("product.label_iva")} />
                                                }
                                                disabled={!checkedTax}
                                            />
                                        </div>
                                        <div style={{ width: (fullScreen) ? '100%' : '25%', marginTop: '20px' }}>
                                            <TextField
                                                InputLabelProps={{ shrink: true }}
                                                label={t("product.label_ieps_rate")}
                                                name="productos_ieps"
                                                required={required.productos_ieps}
                                                InputProps={{
                                                    inputComponent: NumberFormatCustom,
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            %
                                                        </InputAdornment>
                                                    )
                                                }}
                                                inputProps={{
                                                    decimalScale: 2,
                                                    prefix: '',
                                                    fixedDecimalScale: true
                                                }}
                                                disabled={!checkedTax}
                                            />
                                        </div>
                                        <div style={{ width: (fullScreen) ? '100%' : '25%', marginTop: '20px' }}>
                                            <Select
                                                label={t("product.label_iva_withholding")}
                                                name="productos_cat_vat_rates_id"
                                                required={required.productos_cat_vat_rates_id}
                                                data={selectDataIVAWithHolding}
                                                multiple={false}
                                                inputLabelProps={{ shrink: true }}
                                                displayEmpty
                                                input={
                                                    <OutlinedInput notched={true} label={t("product.label_iva_withholding")} />
                                                }
                                                disabled={!checkedTax}
                                            />
                                        </div>
                                        <div style={{ width: (fullScreen) ? '100%' : '25%', marginTop: '20px' }}>
                                            <TextField
                                                InputLabelProps={{ shrink: true }}
                                                label={t("product.label_isr_withholding")}
                                                name="productos_r_isr"
                                                required={required.productos_r_isr}
                                                InputProps={{
                                                    inputComponent: NumberFormatCustom,
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            %
                                                        </InputAdornment>
                                                    )
                                                }}
                                                inputProps={{
                                                    decimalScale: 2,
                                                    prefix: '',
                                                    fixedDecimalScale: true
                                                }}
                                                disabled={!checkedTax}
                                            />
                                        </div>


                                    </>
                                )
                            }
                        </Stack>
                    </>
            },
            /*<Field
                            name="productos_cat_taxobject_id"
                            placeholder={t("product.placeholder_taxobject")}
                            label={t("product.label_taxobject")}
                            required={required.productos_cat_taxobject_id}
                            InputLabelProps={{ shrink: true }}
                            select
                            component={SelectFormAdapter}
                            inputOnChange={onChangeTaxObject}
                        >
                            {
                                selectDataTaxObject.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))
                            }
                        </Field>*/
            /*<Select
                            placeholder={t("product.placeholder_taxobject")}
                            label={t("product.label_taxobject")}
                            name="productos_cat_taxobject_id"
                            multiple={false}
                            required={required.productos_cat_taxobject_id}
                            data={selectDataTaxObject}
                            inputLabelProps={{ shrink: true }}
                            displayEmpty
                            input={
                                <OutlinedInput notched={true} label={t("product.label_iva_withholding")} />
                            }
                            onChange={(e: any) => {
                                console.log(e.target.value)
                            }}
                        />*/
        ];
    }

    const modalProps: any = {
        hasMenuItem: false,
        label: t('product.title'),
        title: t('product.title'),
        formFields: null,
        onSubmit,
        initialValues,
        validateForm,
        required,
        submitting,
        getFormFields,
        icon,
        callback,
        setModalOpen,
        loading
    }

    return (
        <>
            {
                !isModal &&
                <Form
                    onSubmit={onSubmit}
                    initialValues={initialValues}
                    validate={validateForm}
                    render={({ handleSubmit, values }) => {
                        //console.log(errors);
                        //console.log(values);

                        const formFields: any[] = getFormFields(values);

                        return (
                            <form onSubmit={handleSubmit} noValidate>
                                {/* <Paper > */}
                                <>
                                    <Typography variant={"h4"} color={"#000"}>
                                        Crear un concepto
                                    </Typography>

                                    <>
                                        <div
                                            style={{ width: (fullScreen) ? '100vw' : '85vw' }}
                                        >
                                            {formFields.map((item, idx) => (
                                                <>
                                                    {item.field}
                                                </>
                                            ))}
                                        </div>
                                    </>
                                </>

                                <LoadingButton
                                    sx={{ mt: 3, mr: 1 }}
                                    //fullWidth
                                    size="large"
                                    type="submit"
                                    variant="contained"
                                    loading={submitting}
                                >
                                    {t("common.save")}
                                </LoadingButton>

                                {/* </Paper> */}
                            </form>
                        );
                    }}
                />
            }

            {
                isModal &&
                <MenuItemModalForm
                    {...modalProps}
                />
            }
        </>
    );
}

export default ProductForm;
